import { TICKET_STATUS_COLORS } from "entities/customerTickets/constants";
import { TicketStatus as Status } from "entities/customerTickets/types";
import { type FC } from "react";
import StatusChip from "shared/components/StatusChip";

type Props = {
  status: Status;
};

const TicketStatus: FC<Props> = ({ status }) => {
  return (
    <StatusChip color={TICKET_STATUS_COLORS[status as Status]} title={status} />
  );
};

export default TicketStatus;
